import { get } from './request';

export default {
  getPhrases () {
    return get('/phrases/', { authorize: false });
  },
};
